/**
 * Tracks which upload jobs have already been surfaced to the user via the
 * upload modal's inline success view, so the global toast listener can skip
 * them and avoid showing a duplicate notification.
 */

const handledByModal = new Set<string>();

export function markHandledByModal(jobId: string): void {
  handledByModal.add(jobId);
}

export function isHandledByModal(jobId: string): boolean {
  return handledByModal.has(jobId);
}
